import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/timetable/TimeTableAction";
import { 
  CustomSelect,
  DeleteButton,
  ExportButton,
  SuccessButton,
  TimetableType,
  copyTimetable,
  deletionAlert,
  downloadTimetableTemplate,
  emptyInputAlert,
  exportTimetableToExcel,
  exportTimetableToPDF,
  getAuthorities,
  getDayAndHourData,
  noFileAlert,
  noTableIdAlert,
  nonExcelFormatAlert,
  printTimetable,
  redirectToPages,
  resultAlert
} from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import { 
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { TimetableEditForm } from "./TimeTableEditForm";
import { ImportFromExcel } from "./ImportFromExcel";

export function TimetableEdit({
  history,
  match: {
    params: { editTable }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  const [tableType, setTableType] = useState(0);
  const [term, setTerm] = useState(0);
  const [term2, setTerm2] = useState(1);
  const [semester, setSemester] = useState(0);
  const [table, setTable] = useState("");
  const [tableId, setTableId] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const openDialog = () => setShowDialog(true);
  const closeDialog = () => setShowDialog(false);
  const dispatch = useDispatch();
  const { 
    actionsLoading,
    isSuccess,
    type,
    authorities,
    currentActiveTerm,
    currentActiveSemester,
    courses,
    sections,
    teachers,
    courseHours,
    dayAndHourData
  } = useSelector(
    (state) => ({
      actionsLoading: state.timetable.actionsLoading,
      isSuccess: state.timetable.isSuccess,
      type: state.timetable.type,
      authorities: state.timetable.authorities,
      currentActiveTerm: state.auth.user.currentActiveTerm,
      currentActiveSemester: state.auth.user.currentActiveSemester,
      courses: state.timetable.courses,
      sections: state.timetable.sections,
      teachers: state.timetable.teachers,
      courseHours: state.timetable.courseHours,
      dayAndHourData: state.timetable.dayAndHourData
    }),
    shallowEqual
  );
  const options = editTable === "sinif-duzenle" ? sections : editTable === "ogretmen-duzenle" ? teachers : [];

  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized, isExportationAuthorized } = getAuthorities(authorities);

  useEffect(() => {
    setTerm(currentActiveTerm);
    setTerm2(currentActiveTerm + 1);
    setSemester(currentActiveSemester);
    dispatch(actions.getList());
    return () => dispatch(actions.cleanTimetableState());
  }, [currentActiveTerm, currentActiveSemester, dispatch]);

  useEffect(() => {
    let _title = "Ders Programı Düzenle";
    let _table = editTable === "sinif-duzenle" ? "Sınıf" : editTable === "ogretmen-duzenle" ? "Öğretmen" : "";
    let _type = editTable === "sinif-duzenle" ? TimetableType.Section : editTable === "ogretmen-duzenle" ? TimetableType.Teacher : TimetableType.Both;
    _title = _table + " " + _title;
    setTitle(_title);
    setTable(_table);
    setTableType(_type);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editTable]);

  /** Belli Bir Sınıf veya Öğretmene Ait Ders Programını Kaydeder */
  const saveTimetable = (dayAndHourData) => {    
    if (!term || !semester || !tableId) {
      emptyInputAlert();
      return;
    }
    const values = {
      timetableType: tableType,
      term: term,
      semester: semester,
      tableId: tableId,
      dayAndHourData: dayAndHourData
    };
    dispatch(actions.saveTimetable(values)).then((result) => onResult(result));
  }

  /** Belli Bir Sınıf veya Öğretmene Ait Ders Programını Siler */
  const deleteTimetable = () => {
    if (!term || !semester || !tableId) {
      emptyInputAlert();
      return;
    }
    deletionAlert().then(result => {
      if (result.isConfirmed) {
        const values = {
          timetableType: tableType,
          term: term,
          semester: semester,
          tableId: tableId
        };
        dispatch(actions.deleteTimetable(values)).then((result) => onResult(result));
      }
    });
  }

  /** Belli Bir Sınıf veya Öğretmene Ait Ders Programını Excele Aktarır */
  const exportToExcel = () => {
    if (!tableId) {
      noTableIdAlert(tableType);
      return;
    }
    const sheetname = "Ders Programı";
    const { header, timetable } = getHeaderAndTimetable();
    const filename = term + " - " + (term + 1) + " Eğitim Öğretim Yılı " + semester + ". Dönem " + header + " Ders Programı";
    exportTimetableToExcel({ tableType, courseHours, timetable, filename, sheetname });
  }

  /** Belli Bir Sınıf veya Öğretmene Ait Ders Programını PDF e Aktarır */
  const exportToPDF = () => {
    if (!tableId) {
      noTableIdAlert(tableType);
      return;
    }
    const { header, timetable } = getHeaderAndTimetable();
    const filename = term + " - " + (term + 1) + " Eğitim Öğretim Yılı " + semester + ". Dönem " + header + " Ders Programı";
    exportTimetableToPDF({ tableType, courseHours, timetable, filename });
  }

  /** Belli Bir Sınıf veya Öğretmene Ait Ders Programını Yazdırma Penceresini Açar */
  const print = () => {
    if (!tableId) {
      noTableIdAlert(tableType);
      return;
    }
    let { header, timetable } = getHeaderAndTimetable();
    header = term + " - " + (term + 1) + " Eğitim Öğretim Yılı " + semester + ". Dönem " + header + " Ders Programı";
    printTimetable({ tableType, header, courseHours, timetable });
  }

  /** Belli Bir Sınıf veya Öğretmene Ait Ders Programını Panoya Kopyalar */
  const copy = () => {
    if (!tableId) {
      noTableIdAlert(tableType);
      return;
    }
    let { header, timetable } = getHeaderAndTimetable();
    header = term + " - " + (term + 1) + " Eğitim Öğretim Yılı " + semester + ". Dönem " + header + " Ders Programı";
    copyTimetable({ tableType, header, courseHours, timetable });
  }

  /** ... Elde Eder */
  const getHeaderAndTimetable = () => {
    let header = "";
    const timetable = [];    

    if (tableType === TimetableType.Section) {
      header = sections.find(section => section.value === tableId).label;

      dayAndHourData.forEach(data => {
        const course = courses.find(course => data.firstId === course.value);
        const teacher = teachers.find(teacher => data.secondId === teacher.value);
        const courseName = course ? course.label : "";
        const teacherName = teacher ? teacher.label.split("(")[0] : "";
        timetable.push({ day: data.day, hour: data.hour, courseName, teacherName });
      });

    } else if (tableType === TimetableType.Teacher) {
      header = teachers.find(teacher => teacher.value === tableId).label;

      dayAndHourData.forEach(data => {
        const course = courses.find(course => data.secondId === course.value);
        const section = sections.find(section => data.firstId === section.value);
        const courseName = course ? course.label : "";
        const sectionName = section ? section.label : "";
        timetable.push({ day: data.day, hour: data.hour, courseName, sectionName });
      });
    }

    return { header, timetable };
  }

  /** Sınıf veya Öğretmen Ders Programı Excele Aktarım Şablonunu İndirir */
  const downloadTemplate = () => {
    const options = tableType === TimetableType.Section ? teachers : tableType === TimetableType.Teacher ? sections : [];
    downloadTimetableTemplate({ tableType, courseHours, courses, options });
  }

  /** Belli Bir Sınıf veya Öğretmene Ait Ders Programını Belli Bir Excel Dosyasından Yükler */
  const importFromExcel = (file) => {
    if (!term || !semester || !tableId) {
      emptyInputAlert();
      return;
    }
    if (!file) {
      noFileAlert();
      return;
    }
    if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      nonExcelFormatAlert();
      return;
    }
    const reader = new FileReader();
    reader.onload = async function(e) {      
      const values = {
        timetableType: tableType,
        term: term,
        semester: semester,
        tableId: tableId,
        dayAndHourData: await getDayAndHourData({ tableType, courseHours, courses, sections, teachers, e })
      };
      dispatch(actions.saveTimetable(values)).then((result) => onResult(result));
    }
    reader.readAsArrayBuffer(file);
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/ders-programi"), 2500);
  };

  const btnRef = useRef();  
  const saveTimetableClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
  
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <>
      <ImportFromExcel
        title="Excelden Ders Programı Yükleme"
        downloadTemplate={downloadTemplate}
        importFile={importFromExcel}
        showDialog={showDialog}
        closeDialog={closeDialog}
      />
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title={title}>
          <CardHeaderToolbar>
            {
              isExportationAuthorized &&
              <ExportButton
                exportToExcel={exportToExcel}
                exportToPDF={exportToPDF}
                print={print}
                copy={copy}
              />
            }
            {
              isEditionAuthorized &&
              <SuccessButton
                path="Files/Import"
                title="Excelden Yükle"
                method={openDialog}
              />
            }
            <button
              type="submit"
              className="btn btn-primary ml-2"
              onClick={saveTimetableClick}
            >
              Kaydet
            </button>
            {
              isDeletionAuthorized &&
              <DeleteButton
                title="Sil"
                method={deleteTimetable}
              />
            }
          </CardHeaderToolbar>        
        </CardHeader>
        <CardBody>
          <div className="form-group row">
            <label className="col-3 mt-3">
              Yıl <span>*</span>
            </label>
            <div className="col-2">
              <input
                type="number"
                className="form-control"
                min={1}
                value={term}
                placeholder="Yıl"
                onChange={e => {
                  if (e.target.value && semester && tableId) dispatch(actions.getTeachersAndTimetable(table, e.target.value, semester, tableId));
                  const value2 = e.target.value !== "" ? parseInt(e.target.value) + 1 : "";
                  setTerm(e.target.value);
                  setTerm2(value2);
                }}
              />
            </div>
            <div className="col-2">
              <input className="form-control" value={term2} readOnly />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3 mt-3">
              Dönem <span>*</span>
            </div>
            <div className="col-2">
              <input
                type="number"
                className="form-control"
                min={1}
                max={4}
                value={semester}
                placeholder="Dönem"
                onChange={e => {
                  if (term && e.target.value && tableId) dispatch(actions.getTimetable(table, term, e.target.value, tableId));
                  setSemester(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="form-group row mb-10">
            <div className="col-3 mt-3">
              {table} <span>*</span>
            </div>
            <div className="col-4">
              <CustomSelect
                options={options}
                onChange={option => {
                  if (term && semester && option.value) dispatch(actions.getTimetable(table, term, semester, option.value));
                  setTableId(option.value);
                }}
              />
            </div>
          </div>

          <TimetableEditForm
            editTable={editTable}
            courses={courses}
            sections={sections}
            teachers={teachers}
            courseHours={courseHours}
            dayAndHourData={dayAndHourData}
            btnRef={btnRef}
            saveTimetable={saveTimetable}
          />
        </CardBody>
      </Card>
    </>
  );
}